import { ReactNode } from 'react';
import { CssVarsProvider, extendTheme } from '@mui/joy/styles';
import {
  ThemeProvider as MaterialThemeProvider,
  THEME_ID as MATERIAL_THEME_ID,
  createTheme as createMaterialTheme
} from '@mui/material/styles';

const materialTheme = createMaterialTheme();

const theme = extendTheme({
  fontFamily: {
    display: 'SamsungOne-400, sans-serif',
    body: 'SamsungOne-400, sans-serif'
  },
  components: {
    JoyTable: {
      styleOverrides: {
        root: {
          tableLayout: 'auto',
          background: '#fff',
          thead: {
            tr: {
              th: {
                background: '#fff',
                padding: 15
              }
            }
          },
          tbody: {
            tr: {
              td: {
                padding: 15
              }
            }
          }
        }
      }
    }
  }
});

export function ThemeContext({ children }: { children: ReactNode }) {
  return (
    <MaterialThemeProvider theme={{ [MATERIAL_THEME_ID]: materialTheme }}>
      <CssVarsProvider theme={theme}>{children}</CssVarsProvider>
    </MaterialThemeProvider>
  );
}
